// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var onDomEvent = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var bind = Control_Bind.bind((MonadCleanup1.Monad0()).Bind1());
    var liftEffect = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var onCleanup = Control_Monad_Cleanup.onCleanup(MonadCleanup1);
    return function (eventType) {
        return function (node) {
            return function (handler) {
                return bind(liftEffect(Specular_Dom_Browser.addEventListener(eventType)(handler)(node)))(function (unsub) {
                    return onCleanup(unsub);
                });
            };
        };
    };
};
var liftBuilderWithRun = function (dict) {
    return dict.liftBuilderWithRun;
};
var liftBuilder = function (dict) {
    return dict.liftBuilder;
};
var monadDomBuilderReaderT = function (dictMonadDomBuilder) {
    var Monad0 = dictMonadDomBuilder.Monad0();
    var lift1 = lift(Monad0);
    var liftBuilder1 = liftBuilder(dictMonadDomBuilder);
    var liftBuilderWithRun1 = liftBuilderWithRun(dictMonadDomBuilder);
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    return {
        liftBuilder: function (b) {
            return lift1(liftBuilder1(b));
        },
        liftBuilderWithRun: function (fn) {
            return function (e) {
                return liftBuilderWithRun1(function (benv, run) {
                    return fn(benv, function (benv$prime, m) {
                        return run(benv$prime, Control_Monad_Reader_Trans.runReaderT(m)(e));
                    });
                });
            };
        },
        Monad0: function () {
            return monadReaderT;
        }
    };
};
export {
    liftBuilder,
    liftBuilderWithRun,
    onDomEvent,
    monadDomBuilderReaderT
};
